// Default time for smart conversion upsell coachmark to hide itself
export const SMC_DISMISS_TIMEOUT_MS = 15000;
export const ICON_WIDTH = 40;
export const actions = Object.freeze({
  SET_TRACKING_EVENTS: 'SET_TRACKING_EVENTS',
  TRIGGER_SMART_CONVERSION_UPSELL: 'TRIGGER_SMART_CONVERSION_UPSELL',
  LAUNCH_SMART_CONVERSION_PRODUCT: 'LAUNCH_SMART_CONVERSION_PRODUCT',
} as const);
// Values formatted to what haymaker expects
export const UPSELL_EVENTS = Object.freeze({
  COMPLETE_REPLAY: 'replay_completed',
  VIEW_SESSION_HISTORY: 'station_history',
  VIEW_STATION_LIST: 'station_list',
} as const);
export const SmartConversionKeys = Object.freeze({
  IS_QUALIFIED_FOR_UPSELL_KEY: 'IS_QUALIFIED_FOR_UPSELL',
  IS_SMART_CONVERSION_ENABLED_KEY: 'IS_SMART_CONVERSION_ENABLED',
  HAYMAKER_URL_KEY: 'HAYMAKER_URL',
  TRACKING_EVENTS_KEY: 'TRACKING_EVENTS',
} as const);
export const TRACKING_EVENTS = Object.freeze({
  CONVERSION: 'CONVERSION',
  IMPRESSION: 'IMPRESSION',
  CLICK: 'CLICK',
  DISMISS: 'DISMISS',
  ENGAGEMENT: 'ENGAGEMENT',
  CLOSE: 'CLOSE',
} as const);
export const StatusCodes = Object.freeze({
  UNRECOGNIZED_RESPONSE: 1,
  EMPTY_UPSELL_DATA: 2,
  UNRECOGNIZED_TRACKING_EVENTS: 3,
  NETWORK_ERROR: 4,
} as const);
